import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { CustomLoader, LoaderContainer, Text, } from './styles';
export const MarginStateLoader = ({ hasBackground, }) => {
    const { colors } = useTheme();
    return (_jsx(LoaderContainer, { children: _jsx(CustomLoader, { backgroundColor: hasBackground
                ? colors.surface.default
                : colors.surface.interactiveDefault, foregroundColor: colors.surface.pressed, children: _jsx(Text, {}) }) }));
};
//# sourceMappingURL=MarginStateLoader.js.map